export default __webpack_public_path__ + "static/media/manufactoring.7ce46994.svg";